<template>
  <v-container style="width: 100%; max-width: 1500px">
    <v-row class="d-flex justify-space-between mt-0 mx-auto">
      <div class="d-flex flex-column" style="width: 40%">
        <div class="d-flex mt-2 mb-3">
          <h2 class="title-class">
            {{ title }}
          </h2>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                plain
                style="background-color: transparent"
              >
                <v-switch
                  inset
                  class="mr-2"
                  v-model="switchValue"
                  @change="handleActive($event)"
                ></v-switch>
              </v-btn>
            </template>
            <span>{{ $tc("monitor.active") }}</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
                @click="openDayDialog"
              >
                mdi-calendar
              </v-icon>
            </template>
            <span>{{ $tc("monitor.addDay") }}</span>
          </v-tooltip>
        </div>
        <v-col class="d-flex align-content-space-between flex-wrap ma-0 pa-0">
          <v-card style="width: 100%">
            <div class="d-flex justify-space-between pa-2">
              <toolbar-titles title="Cantidades" />
              <v-text-field
                :label="$tc('date.from')"
                style="max-width: 105px"
                outlined
                hide-details
                dense
                v-model="getQuantities.from"
                readonly
              />
              <v-text-field
                :label="$tc('date.to')"
                style="max-width: 105px"
                outlined
                dense
                hide-details
                v-model="getQuantities.to"
                readonly
              />
            </div>
            <div class="d-flex flex-column align-start ma-2">
              <p class="ma-0 mb-2">
                {{ $tc("monitor.quantitieDay") }}
                <b> {{ getQuantities.CantidadDias }}</b>
              </p>
              <p class="ma-0 mb-2">
                {{ $tc("monitor.quantitiesEmployees") }}
                <b> {{ getQuantities.CantidadEmpleados }}</b>
              </p>
            </div>
          </v-card>

          <v-card style="width: 100%">
            <v-card-actions class="d-flex justify-space-between">
              <toolbar-titles title="Estados" />
              <v-col cols="11" sm="5" md="5" class="only-date-start">
                <span class="mr-1">Fecha</span>
                <v-text-field
                  v-model="formattedDateFrom"
                  class="inputDate"
                  placeholder="dd/mm/yyyy"
                  dense
                  flat
                  solo
                  hide-details
                  maxlength="10"
                  v-mask="'##/##/####'"
                  @change="handleChangeDate"
                />
                <v-menu
                  ref="menuFrom"
                  v-model="menuFrom"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon small class="ml-1" v-bind="attrs" v-on="on"
                      >far fa-calendar</v-icon
                    >
                  </template>
                  <v-date-picker
                    v-model="dateFromInternal"
                    @input="onDateFromPickerInput"
                    @change="menuFrom = false"
                    locale="es"
                    :first-day-of-week="1"
                  />
                </v-menu>
              </v-col>
            </v-card-actions>
            <canvas ref="chartCanvas"></canvas>
          </v-card>
        </v-col>
      </div>

      <div class="container-tables pl-6">
        <div class="buttons">
          <v-btn-toggle
            group
            tile
            color="indigo lighten-2 accent-3"
            v-model="buttonSelected"
          >
            <v-btn
              v-for="(table, index) in tables"
              :key="index"
              @click="selectTable(index)"
            >
              {{ table.title }}
            </v-btn>
          </v-btn-toggle>
        </div>

        <div v-for="(table, index) in tables" :key="index">
          <Table
            v-if="selectedTable === index"
            :headers="table.headers"
            :items="table.items"
            class="table"
          />
        </div>
      </div>
    </v-row>

    <CardAlert
      :showDialog="showDialog"
      :cancel="cancel"
      :confirm="confirm"
      :title="titleAlert"
    />
    <snackbar :alert="showAlert" :textAlert="textAlert" :color="colorAlert" />
    <card-start-day
      :closeDayDialog="closeDayDialog"
      :confirmDay="confirmDay"
      :showDay="showDay"
    />
    <v-dialog v-model="loading" class="dialog__loader" :overlay-opacity="0.3">
      <loader :loading="loading" />
    </v-dialog>
  </v-container>
</template>

<script>
import monitor from "../../store/monitores/monitor";
import Loader from "../Complement/Loader.vue";
import Table from "./Table.vue";
import ToolbarTitles from "../Complement/ToolbarTitles.vue";
import moment from "moment";
import CardAlert from "../Complement/CardAlert.vue";
import Snackbar from "../Complement/Snackbar.vue";
import CardStartDay from "./CardStartDay.vue";
import ButtonsCardList from "@/components/Complement/ButtonsCardList.vue";
import Chart from "chart.js";
import "chartjs-plugin-datalabels";
import DateWithCheck from "../Complement/DateWithCheck.vue";
import date from "@/store/common/date";

const colorMap = {
  Presentes: "#2196F3", // Azul
  Ausentes: "#FF9800", // Naranja
  Inconsistencias: "#4CAF50", // Verde
  HorasCaidas: "#FFC107", // Ámbar
  Tardes: "#9C27B0", // Púrpura
  Retiros: "#F44336", // Rojo
  LicenciasDias: "#009688", // Teal
  LicenciasHoras: "#FFEB3B", // Amarillo
};

export default {
  name: "MonitorCA3",
  components: {
    Loader,
    Table,
    ToolbarTitles,
    CardAlert,
    Snackbar,
    CardStartDay,
    ButtonsCardList,
    DateWithCheck,
  },
  data() {
    return {
      menuFrom: false,
      dateFromInternal: moment().format("YYYY-MM-DD"),
      selectedTable: 0,
      buttonSelected: 0,
      title: this.$tc("monitor.monitor"),
      switchValue: false,
      optionsQuantities: {
        chart: {
          type: "donut",
        },
        labels: [],
      },
      seriesQuantities: [],
      loading: true,
      optionsState: {
        chart: {
          type: "donut",
        },
        labels: [],
      },
      seriesState: [],
      headersLogs: [
        {
          text: "Fecha",
          value: "dateE",
          class: "primary secondary--text",
          sortable: false,
        },
        {
          text: "Comentario",
          value: "comment",
          class: "primary secondary--text",
        },
        {
          text: "Error",
          value: "errorId",
          class: "primary secondary--text",
          align: "center",
        },
      ],
      headersErrors: [
        {
          text: "Fecha",
          value: "date",
          class: "primary secondary--text",
          sortable: false,
        },
        {
          text: "Descripción",
          value: "description",
          class: "primary secondary--text",
        },
        {
          text: "Empleado",
          value: "empId",
          class: "primary secondary--text",
          align: "center",
        },
      ],
      headersConfig: [
        { text: "Nombre", value: "name", class: "primary secondary--text" },
        {
          text: "Descripción",
          value: "description",
          class: "primary secondary--text",
        },
        {
          text: "Valor correcto",
          value: "valueCorr",
          class: "primary secondary--text",
        },
        {
          text: "Valor defectuoso",
          value: "valueDeff",
          class: "primary secondary--text",
        },
      ],
      titleAlert: "",
      showDialog: false,
      saveEvent: null,
      showAlert: false,
      textAlert: "",
      colorAlert: "",
      showDay: false,
      widthGraf: 0,
      chartInstance: null,
    };
  },
  mounted() {
    this.dispatcher();
    this.widthGraf = innerHeight;
  },
  computed: {
    dateFrom: {
      get() {
        return monitor.state.dateFrom;
      },
      set(date) {
        if (!moment(date, "YYYY-MM-DD", true).isValid()) return;
        this.setDate(date);
      },
    },
    formattedDateFrom: {
      get() {
        if (!this.dateFrom) return "DD/MM/YYYY";
        const m = moment(this.dateFrom, "YYYY-MM-DD", true);
        return m.isValid() ? m.format("DD/MM/YYYY") : "";
      },
      set(value) {
        const parsed = moment(value, "DD/MM/YYYY", true);
        if (parsed.isValid()) {
          this.dateFrom = parsed.format("YYYY-MM-DD");
        }
      },
    },
    getLogs() {
      return monitor.state.logs;
    },
    getErrors() {
      return monitor.state.errors;
    },
    getConfig() {
      return monitor.state.config;
    },
    getQuantities() {
      return monitor.state.quantities;
    },
    tables() {
      return [
        {
          headers: this.headersLogs,
          items: this.getLogs,
          title: "Logs",
        },
        {
          headers: this.headersErrors,
          items: this.getErrors,
          title: "Errores",
        },
        {
          headers: this.headersConfig,
          items: this.getConfig,
          title: "Configuración",
        },
      ];
    },
  },
  methods: {
    onDateFromPickerInput(value) {
      if (!moment(value, "YYYY-MM-DD", true).isValid()) return;
      this.setDate(value);
      this.dateFromInternal = value;
    },
    setDate(dates) {
      monitor.commit("setDateFrom", dates);
      this.handleChangeDate();
    },
    initChart() {
      const ctx = this.$refs.chartCanvas.getContext("2d");
      const status = monitor.state.status || {};
      const labels = Object.keys(status);
      const data = Object.values(status);

      this.chartInstance = new Chart(ctx, {
        type: "doughnut",
        data: {
          labels,
          datasets: [
            {
              data,
              backgroundColor: labels.map(
                (label) => colorMap[label] || "#9E9E9E"
              ),
            },
          ],
        },
        options: this.getChartOptions(),
        /*           tooltips: {
            callbacks: {
              label: function (tooltipItem, data) {
                const dataset = data.datasets[tooltipItem.datasetIndex];
                const total = dataset.data.reduce(
                  (sum, value) => sum + (isNaN(value) ? 0 : value),
                  0
                ); // Asegurar que solo sume números válidos
                const currentValue = dataset.data[tooltipItem.index];
                const percentage =
                  total > 0 ? ((currentValue / total) * 100).toFixed(1) : 0;

                return `${
                  data.labels[tooltipItem.index]
                }: ${currentValue} (${percentage}%)`;
              },
            },
          }, */
      });
    },
    getChartOptions() {
      return {
        responsive: true,
        legend: {
          position: "right",
          labels: {
            fontColor: "#333",
            boxWidth: 10,
            usePointStyle: true,
            padding: 15,
          },
        },
        plugins: {
          datalabels: {
            formatter: (value, context) => {
              const total = context.chart.data.datasets[0].data.reduce(
                (a, b) => a + b,
                0
              );
              const percentage = total ? (value / total) * 100 : 0;
              return percentage >= 2 ? `${percentage.toFixed(1)}%` : null;
            },
            color: "#273746",
            font: {
              weight: "bold",
              size: 16,
            },
          },
        },
      };
    },
    updateChart() {
      if (this.chartInstance) {
        const status = monitor.state.status || {};
        const labels = Object.keys(status);
        const data = Object.values(status);
        this.chartInstance.data.labels = labels;
        this.chartInstance.data.datasets[0].data = data;
        this.chartInstance.data.datasets[0].backgroundColor = labels.map(
          (label) => colorMap[label] || "#9E9E9E"
        );
        this.chartInstance.update();
      }
    },
    selectTable(index) {
      this.buttonSelected = index;
      this.selectedTable = index;
    },
    getGrafData(data, series, options) {
      Object.entries(data).forEach(([key, value]) => {
        if (value >= 0 && value != null) {
          series.push(value);
          options.labels.push(key);
        }
      });
    },
    handleChangeDate() {
      monitor
        .dispatch(
          "getStatus",
          moment(this.formattedDateFrom, "DD/MM/YYYY").format("YYYY-MM-DD")
        )
        .then(() => {
          this.updateChart();
        });
    },
    handleActive(event) {
      this.showDialog = true;
      this.titleAlert =
        event == true
          ? this.$tc("monitor.activeMonitor")
          : this.$tc("monitor.desactiveMonitor");
      console.log(event);
      this.saveEvent = event;
    },
    cancel() {
      this.saveEvent = null;
      this.showDialog = false;
      this.switchValue = !this.switchValue;
    },
    confirm() {
      this.loading = true;
      monitor
        .dispatch("activate", this.saveEvent)
        .then(() => {
          this.alertShow(
            this.$tc("monitor.success"),
            "primary",
            !this.showAlert
          );
          this.dispatcher();
        })
        .catch((error) => {
          this.alertShow(
            error.response.data.error.message,
            "error",
            !this.showAlert
          );
        });
      this.showDialog = false;
    },
    alertShow(text, color, alert) {
      this.showAlert = alert;
      this.textAlert = text;
      this.colorAlert = color;
    },
    dispatcher() {
      monitor.dispatch("getStatus").then(() => {
        this.loading = false;
        this.initChart();
      });
      monitor.dispatch("getQuantities");
      monitor.dispatch("getLogs");
      monitor.dispatch("getErrors");
      monitor.dispatch("getConfig");
    },
    openDayDialog() {
      this.showDay = true;
    },
    closeDayDialog() {
      this.showDay = false;
    },
    confirmDay() {
      monitor.commit("setDayStart", date.state.dateFrom);
      this.loading = true;
      monitor
        .dispatch("startDate")
        .then(() => {
          this.alertShow(
            this.$tc("monitor.success"),
            "primary",
            !this.showAlert
          );
          this.dispatcher();
        })
        .catch((error) => {
          this.alertShow(
            error.response.data.error.message,
            "error",
            !this.showAlert
          );
        });
      this.showDay = false;
    },
  },
};
</script>

<style scoped>
.only-date-start {
  display: flex;
  align-items: center;
  max-width: 190px;
  max-height: 40px;
  border-radius: 5px;
  border: 1px solid rgb(126, 126, 126);
  padding: 5px;
}
.container-tables {
  flex: 1;
}
.table {
  width: 100%;
  border-collapse: collapse;
}
.table th,
.table td {
  border: 1px solid #444;
  padding: 8px;
  text-align: left;
}
.table th {
  background-color: #333;
}
.title-class {
  color: #586271;
  font-weight: lighter !important;
  text-shadow: 1px 1px #384b6d;
  margin-right: 20px;
}
</style>
